import React, { useRef} from "react";
import Slider from "react-slick";

export default function ServiceEquipment() {
    const sliderRef = useRef(null);

    const settings2 = {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1200,
        pauseOnHover: true,
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 3,},
            },
            {
            breakpoint: 767,
            settings: { slidesToShow: 2,},
            },
            {
            breakpoint: 599,
            settings: { slidesToShow: 1,},
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="service-equip-arrow" onClick={() => sliderRef.current.slickPrev()}>
            <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div className="service-equip-arrow" onClick={() => sliderRef.current.slickNext()}>
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        </>
    );

    return (
        <>
        <section className="servicepage-equipment">
            <div className="container">
                <div className="row">

                    <div className="col-md-12">
                        <div className="service-equip-head">
                            <div>
                                <span className="gradient-color">Equipment We Service</span>
                                <h3 className="heading">Precision Service For <br/> The Equipment You Rely On</h3>
                            </div>
                            <div>
                                <CustomArrows />
                            </div>
                        </div>

                        <Slider {...settings2} ref={sliderRef} className="service-equip-slider">
                            <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo1.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>Milnor</p>
                            </div>

                            <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo2.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>Image</p>
                            </div>

                            <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo3.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>Laco Machinery</p>
                            </div>

                            <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo4.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>Forenta</p>
                            </div>


                            <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo5.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>Pony</p>
                            </div>

                            {/* <div className="service-equip-item">
                                <div>
                                    <img src="/assets/images/service-logo6.webp" alt="logo" loading="lazy"/>
                                </div>
                                <p>ADC</p>
                            </div> */}
                        </Slider>
                    </div>

                </div>
            </div>
        </section>
        </>
    )
}
